import React, {useEffect, useState} from "react";
import "./FAQPage.css"
import open from "asset/icon/ic_drop_down_black_24dp.png";
import close from "asset/icon/ic_drop_up_black_24dp.png";
import {useTranslation} from "react-i18next";
import langJson from "lang/lang.en.json";

function CallbackAccordionIconClick (item,param){
    if(param.classList.contains("closed")){
        param.classList.replace("closed","open");
        param.querySelector("img").src = close;
    }else if(param.classList.contains("open")){
        param.classList.replace("open","closed");
        param.querySelector("img").src = open;
    }
}

function FAQPage(props) {
    const { t } = useTranslation();
    const faqList = [];
    Object.keys(langJson).forEach((key)=>{
        if(key.includes("FAQ_0")){
            faqList.push(key);
        }
    });

    return (
        <div className={"faq-page"}>
            <div className={"faq-container"}>
                <h2 className={"faq-title"}>Minting FAQs</h2>

                <ul className={"faq-list"}>
                    {
                        faqList.map((value,index)=>{
                            return (
                            <li key={"faq_"+index} className={"faq-wrap closed"}
                                onClick={(e) => {CallbackAccordionIconClick(e,e.currentTarget)}}>
                                <div className={"faq"}>
                                    <div className={"question-wrap"}>
                                        <div className={"question"}>
                                            {t(value)}
                                        </div>
                                        <div className={"accordion-icon"}>
                                            <img src={open} alt={"open"}/>
                                        </div>
                                    </div>
                                    <div className={"answer"}>
                                     <pre>
                                        {t([value.slice(0, 3), '_A', value.slice(3)].join(''))}
                                    </pre>
                                    </div>
                                </div>
                            </li>)
                        })
                    }
                </ul>
            </div>
        </div>
    )
}

export default FAQPage;